import { createTheme, ThemeProvider } from "@mui/material";
import React from "react";
export const TrainTheme = createTheme({
  palette: {
    primary: {
      light: "#7986cb",
      main: "#006B8A",
      dark: "#006B8A",
      contrastText: "#fff",
    },
    secondary: {
      light: "#ff4081",
      main: "#f50057",
      dark: "#c51162",
      contrastText: "#fff",
    },
    error: {
      main: "#9D0009",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          ".primary&:hover": {
            backgroundColor: "#004d64",
            color: "#ffffff",
          },
          ".primary&:active": {
            backgroundColor: "#004357",
            color: "#ffffff",
          },
          ".primary&:focus": {
            backgroundColor: "#044153",
            color: "#ffffff",
          },
          ".secondary&:active": {
            backgroundColor: "#ABCDD7",
            color: "#004357",
          },
        },
      },
    },
  },
});
export const TrainThemeProvider = (props) => {
  return <ThemeProvider theme={TrainTheme}>{props.children}</ThemeProvider>;
};
